import React from 'react'
import { useGiftOrderDetails } from './hooks'
import { CButton, CCard, CCardBody, CCardHeader } from '@coreui/react-pro'
import { colorGiftOrderStatuses, EGiftOrderStatuses } from '../const'
import { Button, Divider, Tag } from 'antd'
import { getGiftOrderDetailsStatus } from './utils'
import { ActionChangeStatusModal } from '../atoms/actionChangeStatusModal/component'
import { path } from '../../../../libs'
import { submitActionStatus } from '../atoms/actionChangeStatusModal/model'
import { Guard } from '../../../../features/session/guard'

export const GiftOrderDetail = () => {
  const { giftOrder, loading } = useGiftOrderDetails()

  if (loading) {
    return <div>Downloading</div>
  }

  return (
    <div>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Gift order {giftOrder.id}</strong>
        </CCardHeader>
        <CCardBody>
          <div className="mt-2">
            <span className="text-muted">Change status:</span>{' '}
            {getGiftOrderDetailsStatus(
              giftOrder.status as EGiftOrderStatuses,
              giftOrder.gift?.giftType,
            ).map((status) => {
              if (status === EGiftOrderStatuses.CANCELED) {
                return (
                  <Guard permission={['edit_gift_order', 'process_gift_order']}>
                    <ActionChangeStatusModal
                      className="ms-2"
                      status={EGiftOrderStatuses.CANCELED}
                      data={giftOrder}
                    ></ActionChangeStatusModal>
                  </Guard>
                )
              } else if (status === EGiftOrderStatuses.SENT) {
                return (
                  <Guard permission={['edit_gift_order', 'process_gift_order']}>
                    <ActionChangeStatusModal
                      className="ms-2"
                      status={EGiftOrderStatuses.SENT}
                      data={giftOrder}
                    ></ActionChangeStatusModal>
                  </Guard>
                )
              } else {
                return (
                  <Guard permission={['edit_gift_order', 'process_gift_order']}>
                    <Button
                      className="ms-2"
                      style={{
                        color: '#ffffff',
                        backgroundColor: colorGiftOrderStatuses(status),
                      }}
                      onClick={() => {
                        submitActionStatus({
                          id: String(giftOrder.id),
                          status,
                        })
                      }}
                    >
                      {EGiftOrderStatuses[status]}
                    </Button>
                  </Guard>
                )
              }
            })}
          </div>
          <Divider />
          <div className="mt-2">
            <span className="text-muted">Order id:</span> {giftOrder.id}
          </div>
          <div className="mt-2">
            <span className="text-muted">Status:</span>{' '}
            <Tag color={colorGiftOrderStatuses(giftOrder.status)}>
              {
                EGiftOrderStatuses[
                  giftOrder.status as keyof typeof EGiftOrderStatuses
                ]
              }
            </Tag>
          </div>
          <Divider />
          <div className="mt-2">
            <span>
              <strong>Information about client</strong>
            </span>{' '}
          </div>
          <div className="mt-2">
            <CButton
              color="primary"
              className="me-2"
              title={'Edit'}
              href={path.clients.details(String(giftOrder.client.clientId))}
            >
              Go to client page
            </CButton>
          </div>
          <div className="mt-2">
            <span className="text-muted">Client name:</span>{' '}
            {giftOrder.client.fullName}
          </div>
          <div className="mt-2">
            <span className="text-muted">Crown balance:</span>{' '}
            {giftOrder.client.crown}
          </div>
          <Divider />
          <div className="mt-2">
            <strong>Information about order</strong>
          </div>
          <div className="mt-2">
            <span className="text-muted">Gift Name:</span>{' '}
            {giftOrder.gift?.name}
          </div>
          {giftOrder.fileUrl && (
            <div className="mt-2">
              <div className="text-muted">Screenshot for review:</div>
              <img
                src={giftOrder.fileUrl}
                alt="screenshot"
                style={{
                  width: '50%',
                  objectFit: 'contain',
                  border: '1px solid black',
                  borderRadius: '4px',
                }}
              />
            </div>
          )}
          <div className="mt-2">
            <span className="text-muted">Gift price:</span>{' '}
            {giftOrder.giftPrice}
          </div>
          {giftOrder.deliveryInfo && (
            <>
              <div className="mt-2">
                <span>Delivery information:</span>
              </div>
              <div className="ms-5">
                <div className="mt-2">
                  <span className="text-muted">Name:</span>{' '}
                  {`${giftOrder.deliveryInfo.first_name} ${giftOrder.deliveryInfo.last_name}`}
                </div>
                <div className="mt-2">
                  <span className="text-muted">Country:</span>{' '}
                  {giftOrder.deliveryInfo?.country}
                </div>
                <div className="mt-2">
                  <span className="text-muted">Address:</span>{' '}
                  {giftOrder?.deliveryInfo.address}
                </div>
                <div className="mt-2">
                  <span className="text-muted">Phone:</span>{' '}
                  {giftOrder?.deliveryInfo.contact_number}
                </div>
                {giftOrder?.deliveryInfo.postal_code && (
                  <div className="mt-2">
                    <span className="text-muted">Postal code:</span>{' '}
                    {giftOrder?.deliveryInfo.postal_code}
                  </div>
                )}
                {giftOrder?.deliveryInfo.size && (
                  <div className="mt-2">
                    <span className="text-muted">Size:</span>{' '}
                    {giftOrder?.deliveryInfo.size}
                  </div>
                )}
              </div>
            </>
          )}
          <div className="mt-2">
            <span>Manager Comment:</span> {giftOrder.managerComment}
          </div>
        </CCardBody>
      </CCard>
    </div>
  )
}
